import {useState} from 'react';
import {Helmet} from 'react-helmet';
import PropTypes from 'prop-types';
import {Card, AppBar, Tabs, Tab} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import Authentication from 'Authentication';
import BasicLogin from 'Login/Presentation/BasicLogin';
import AadLogin from 'Login/Presentation/AadLogin';

const styles = (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    textAlign: 'center',
    backgroundImage: !process.env.REACT_APP_BACKGROUND_IMAGE
      ? 'none'
      : `url("${process.env.REACT_APP_BACKGROUND_IMAGE}")`,
    backgroundColor: theme.palette.background.paper,
  },
});

function LoginContainer(props) {
  const {classes} = props;
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [tabValue, setTabValue] = useState(0);
  /**
   * The callback function for handling a tab change.
   * @param {object} event The event capturing the change.
   * @param {number} value The position of the selected tab.
   */
  const handleChangeTab = (_event, value) => setTabValue(value);
  /**
   * The callback function for handling a username change.
   * @param {object} event The event capturing the change.
   */
  const handleChangeUsername = ({target: {value}}) => setUsername(value);
  /**
   * The callback function for handling a password change.
   * @param {object} event The event capturing the change.
   */
  const handleChangePassword = ({target: {value}}) => setPassword(value);
  /**
   * The callback function for handling AAD login.
   */
  const handleAadLogin = () => Authentication.aadLogin();
  /**
   * The callback function for handling a basic login request.
   * @param {string} username The username.
   * @param {string} password The password.
   */
  const handleBasicLogin = (username, password) =>
    Authentication.basicLogin(username, password);

  return (
    <div className={classes.root}>
      <Helmet title={process.env.REACT_APP_APP_NAME} defer={false} />
      <Card>
        <AppBar position="static">
          <Tabs value={tabValue} onChange={handleChangeTab}>
            <Tab label="Office 365" />
            <Tab label="Basic" />
          </Tabs>
        </AppBar>
        {tabValue === 0 && <AadLogin onLogin={handleAadLogin} />}
        {tabValue === 1 && (
          <BasicLogin
            username={username}
            password={password}
            onChangeUsername={handleChangeUsername}
            onChangePassword={handleChangePassword}
            onLogin={handleBasicLogin}
          />
        )}
      </Card>
    </div>
  );
}

LoginContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoginContainer);
